import axios from 'axios'
import get from 'lodash/get'
import 'url-search-params-polyfill'

import setActiveCurrency from './setActiveCurrency'
import apiConfiguration from '../utilities/api/apiConfiguration'
import {getClientIdByHotelCode, getEndpointByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const FETCH_EXCHANGE_RATES_BEGIN   = 'FETCH_EXCHANGE_RATES_BEGIN'
export const FETCH_EXCHANGE_RATES_SUCCESS = 'FETCH_EXCHANGE_RATES_SUCCESS'
export const FETCH_EXCHANGE_RATES_FAILURE = 'FETCH_EXCHANGE_RATES_FAILURE'

export const fetchExchangeRatesBegin = () => ({
	type: FETCH_EXCHANGE_RATES_BEGIN,
})

export const fetchExchangeRatesSuccess = exchangeRates => ({
	type: FETCH_EXCHANGE_RATES_SUCCESS,
	payload: exchangeRates
})

export const fetchExchangeRatesError = error => ({
	type: FETCH_EXCHANGE_RATES_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchExchangeRates(currencyCode, selectedCurrency) {
	return (dispatch) => {
    const queryString = require('query-string')
    const urlQuery = queryString.parse(window.location.search)
    let clientId = getClientIdByHotelCode(urlQuery.hotelCode);
		let currentEndpointUrl = getEndpointByHotelCode(urlQuery.hotelCode);

		// URL Params
		let urlParams = {
			base: currencyCode,
			clientId: clientId
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		const exchangeApi = currentEndpointUrl + '/api/forex?' + fetchQuery.toString()

		dispatch(fetchExchangeRatesBegin())
		return axios.get(exchangeApi, apiConfiguration())
			.then((response) => {
				dispatch(fetchExchangeRatesSuccess(get(response, 'data.hydra:member[0].rates')))
			})
			.then(() => {
					// dispatch(setActiveCurrency(currencyCode))
					dispatch(setActiveCurrency(selectedCurrency))
			})
			.catch(error => {
				dispatch(fetchExchangeRatesError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchExchangeRates.js